import React from 'react';
import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import Step from "./Step";
import { GREY7 } from "../../colors";
var Line = styled('div')(function () {
  return {
    background: GREY7,
    width: '42px',
    height: '1px'
  };
});
var CircleSteps = function CircleSteps(_ref) {
  var steps = _ref.steps;
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    alignItems: "center",
    sx: {
      width: 'auto'
    }
  }, steps.map(function (step, idx) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: step.value
    }, /*#__PURE__*/React.createElement(Step, {
      value: step.value,
      selected: step.selected
    }), idx !== steps.length - 1 && /*#__PURE__*/React.createElement(Line, null));
  }));
};
export default CircleSteps;